module.exports = __webpack_public_path__ + "static/media/eye.0b2869a0.svg";